import { StyleSheet } from "react-native"

export const styles = StyleSheet.create({
	chooseDiseaseContainer: {
		flex: 1,
	},
})
